import Icon from '@ant-design/icons';
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

import { IphoneSvg } from './svg/iphone';

export const IphoneIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IphoneSvg} {...props} />
);
